import type { TooltipText } from '@library/types/tooltip';

export const TextWithTitleTooltip = ({
  text,
  title = undefined
}: TooltipText) => {
  const textElements = Array.isArray(text) ? (
    text.map((t) => (
      <p key={t} className="text-soClean-110 text-2xs xl:text-xs">
        {t}
      </p>
    ))
  ) : (
    <p className="text-soClean-110 text-2xs xl:text-xs">{text}</p>
  );

  return (
    <div className="flex flex-col">
      {title && (
        <p className="text-soClean-110 text-2xs pb-2 text-center font-bold capitalize xl:text-xs">
          {title}
        </p>
      )}
      {textElements}
    </div>
  );
};
